module.exports = __webpack_public_path__ + "assets/icon_close.4521f300.svg";